const locale = 'en-US';
const PLATFORM_TIMEZONE = 'America/New_York';
const format = {
  timeZone: PLATFORM_TIMEZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
};

const daysOfMonth = Array.from({ length: 31 }, (_, i) => i + 1);

function formatInPlatformTime(date) {
  const parts = new Intl.DateTimeFormat(locale, format).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type).value;
  return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')}:${get('second')}`;
}

const getCalendarDateForDate = (date) => formatInPlatformTime(date).slice(0, 10);

const calendarDateFormat = /^\d{4}-\d{2}-\d{2}$/;

const makeCalendarDate = (year, month, day) => {
  const pad = (v, len) => String(v).padStart(len, '0');
  const calendarDate = `${pad(year, 4)}-${pad(month, 2)}-${pad(day, 2)}`;
  if (!isValidCalendarDate(calendarDate)) {
    throw new Error(`Invalid calendar date: ${calendarDate}`);
  }
  return calendarDate;
};

const parseCalendarDate = (dateString) => {
  const [year, month, day] = dateString.split('-').map(Number);
  return { year, month, day };
};

const isValidCalendarDate = (dateString) => {
  if (!calendarDateFormat.test(dateString)) {
    return false;
  }
  const { year, month, day } = parseCalendarDate(dateString);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

let clock = () => new Date(); //real clock

const setClock = (newClock) => {
  clock = newClock;
};

const getDate = () => clock();
const getPlatformCalendarDate = () => getCalendarDateForDate(getDate());

const getPlatformDateMidnight = () => parsePlatformTime(getPlatformCalendarDate() + ' 00:00:00');

const shiftCalendarDateByDays = (calendarDate, days) => {
  const { year, month, day } = parseCalendarDate(calendarDate);
  const date = new Date(year, month - 1, day + days);
  return makeCalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
};

const diffCalendarDatesInDays = (calendarDate1, calendarDate2) => {
  const calendarDateToUTC = ({ year, month, day }) => Date.UTC(year, month - 1, day);
  const date1 = calendarDateToUTC(parseCalendarDate(calendarDate1));
  const date2 = calendarDateToUTC(parseCalendarDate(calendarDate2));
  return Math.round((date2 - date1) / (24 * 60 * 60 * 1000));
};

const parsePlatformTime = (dateTimeString) => {
  for (const offset of ['-05:00', '-04:00']) {
    const date = new Date(`${dateTimeString.replace(' ', 'T')}${offset}`);
    if (formatInPlatformTime(date) === dateTimeString) {
      return date;
    }
  }
  throw new Error(`Could not find the right offset for ${dateTimeString} when converting as platform time`);
};

const convertPlatformDateTimeStringToUTC = (dateTimeString) => parsePlatformTime(dateTimeString).toISOString();

export {
  PLATFORM_TIMEZONE,
  daysOfMonth,
  setClock,
  getDate,
  getCalendarDateForDate,
  getPlatformCalendarDate,
  getPlatformDateMidnight,
  makeCalendarDate,
  parseCalendarDate,
  isValidCalendarDate,
  shiftCalendarDateByDays,
  diffCalendarDatesInDays,
  formatInPlatformTime,
  parsePlatformTime,
  convertPlatformDateTimeStringToUTC,
};
